import * as Backbone from "backbone";

export class Timezone extends Backbone.Model {
    getDisplayTimezone() {
        return 'GMT' + this.get('utcOffset') + (this.get('dst') ? ' (DST) ' : '' +
                '\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0') + this.get('examples');
    };

    getDisplayTimezoneShort() {
        return 'GMT' + this.get('utcOffset') + (this.get('dst') ? ' (DST)' : '');
    };
}


// WEBPACK FOOTER //
// ./srv/public/js/models/Timezone.ts